export const PAYMENT_SUCCEEDED = "pwcPaymentSucceeded";
export const PAYMENT_ERRORED = "pwcPaymentErrored";
